import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { EngagementHistoryComponent } from 'src/app/care/engagement/engagement-history/engagement-history.component';
import { EngagementWrapperComponent } from 'src/app/care/engagement/engagement-wrapper/engagement-wrapper.component';

downgradedAngularModule
    .directive('angularEngagementHistory', downgradeComponent({ component: EngagementHistoryComponent }))
    .directive('angularEngagementWrapper', downgradeComponent({ component: EngagementWrapperComponent }))
    ;
